import { BUILD_STATUS } from "@/lib/academy/teaser";

export const PingDot = () => (
  <span aria-hidden="true" className="relative inline-flex w-2 h-2 shrink-0">
    <span className="absolute inset-0 rounded-full bg-[#F6101A] opacity-60 animate-ping" />
    <span className="relative w-2 h-2 rounded-full bg-[#F6101A]" />
  </span>
);

export const SoonStamp = ({ className = "" }) => <span aria-hidden="true" className={`teaser-stamp ${className}`}>Coming soon</span>;

const Segments = ({ filled }) => (
  <span aria-hidden="true" className="col-span-2 grid grid-cols-10 gap-[3px]">
    {Array.from({ length: 10 }, (_, index) => {
      const lead = index === filled - 1 && filled < 10;
      return <span key={index} className={`h-1.5 ${index < filled ? (lead ? "bg-[#F6101A] teaser-blink" : "bg-[#160907]") : "bg-[#E2E4E8]"}`} />;
    })}
  </span>
);

export const BuildStatus = () => (
  <ul data-testid="academy-build-status" aria-label="Academy build status" className="mt-4 pt-4 border-t hairline space-y-3.5">
    {BUILD_STATUS.map(({ id, label, state, filled }) => (
      <li key={id} data-testid={`academy-build-${id}`} className="grid grid-cols-[1fr_auto] gap-x-3 gap-y-1.5 items-center">
        <span className="text-sm text-[#160907] min-w-0">{label}</span>
        <span className="font-space-mono text-[10px] text-[#D00508] whitespace-nowrap">{state}</span>
        <Segments filled={filled} />
      </li>
    ))}
  </ul>
);
